import React, { useRef } from 'react';
import { useCopyToClipboard } from '../helpers/hooks';
import { Alert, selectAllText } from '../helpers/utils';
import FlatCard from './FlatCard';

type CopyProps = {
  info: string;
};

const Copy = ({ info }: CopyProps) => {
  const { copyToClipboard } = useCopyToClipboard();
  const divRef = useRef<HTMLElement>();
  return (
    <FlatCard
      ref={divRef}
      as={'button'}
      onClick={() => {
        copyToClipboard(info).then(() => {
          Alert.info('Copied');
        });
        if (divRef.current) selectAllText(divRef.current);
      }}
      title={{ text: info }}
      containerClassName="p-4 bg-gray-200 text-xs"
    />
  );
};

export default Copy;
